import { render, staticRenderFns } from "./EditPad.vue?vue&type=template&id=639c6d34&scoped=true&"
import script from "./EditPad.vue?vue&type=script&lang=js&"
export * from "./EditPad.vue?vue&type=script&lang=js&"
import style0 from "./EditPad.vue?vue&type=style&index=0&id=639c6d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639c6d34",
  null
  
)

export default component.exports